// eslint-disable-next-line max-classes-per-file
import { IdName } from 'src/app/shared/models/id-name';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';

export class LoadCompetenceRoles {
  static readonly type = '[Competence Roles] Fetch Roles';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllCompetenceRoles {
  static readonly type = '[Competence Roles] Fetch All Roles';
  constructor(public includeDeleted = false, public departmentId?: string) {}
}

export class LoadAllCompetenceRolesForCurrentDepartment {
  static readonly type = '[Competence Roles] Fetch All Roles For Current Department';
  constructor(public includeDeleted = false) {}
}

export class LoadCompetenceRoleById {
  static readonly type = '[Competence Roles] Load Role By Id';
  constructor(public id: string) {}
}

export class CreateCompetenceRole {
  static readonly type = '[Competence Roles] Create Role';
  constructor(public role: IdName) {}
}

export class UpdateCompetenceRole {
  static readonly type = '[Competence Roles] Update Role';
  constructor(public role: IdName) {}
}

export class DeleteCompetenceRole {
  static readonly type = '[Competence Roles] Delete Role';
  constructor(public id: string) {}
}
